import { useState } from "react";
import "./MainPage.css";
import jesus from "../imgs/JesusLoop.gif";
import logoConejo from "../imgs/logo_infonejo.png";
import logoPixel from "../imgs/logo_pxi.png";
import coingecko from "../imgs/CoinGecko Logo.svg";
import jesusLogo from "../imgs/24747.png";
import PriceDisplay from "./PriceDisplay";
import UnityGame from "./UnityGame";
const MainPage = () => {
  const [playTheGame, setPlayTheGame] = useState(false);
  return (
    <>
      {" "}
      {!playTheGame ? (
        <div className="main">
          <div className="card">
            <div className="card-content">
              <div className="jesus">
                {" "}
                <img src={jesusLogo} alt="" />
                <h1>$JESUS</h1>
              </div>

              <PriceDisplay />
              <div className="gecko">
                {" "}
                <p>Data provided by CoinGecko</p>
                <img src={coingecko} alt="" />
              </div>

              <div className="image-container">
                <img src={jesus} alt="" />
              </div>

              <button
                className="button-53"
                onClick={() => setPlayTheGame(true)}
              >
                Play Mini Game
              </button>
              <div className="footer">
                <small>With love from</small>
                <div className="logos">
                  <div className="logos-col">
                    <a href="https://twitter.com/hex_vanilla">
                      <img src={logoConejo} alt="" />
                    </a>
                    <small>HexVanilla</small>
                  </div>
                  <div className="logos-col">
                    <a href="https://www.instagram.com/rodrigosaffie/">
                      <img src={logoPixel} alt="" />
                    </a>
                    <small>PixelIndex</small>
                  </div>
                </div>
              </div>
              <div className="contact">
                <small>Bugs and stuff</small>
                <small>hexvanilla@gmail.com</small>
              </div>
              <small className="disclaimer">
                Disclaimer: This website and mini game are created as a labor of
                love and for entertainment purposes only. We are not affiliated,
                associated, or related in any form with the $JESUS coin Please
                note that any information provided on this website is for
                general informational purposes and should not be considered
                financial advice.
              </small>
            </div>
          </div>
        </div>
      ) : (
        <UnityGame />
      )}
    </>
  );
};

export default MainPage;
